/* jshint esnext: true */
/**
 * topNav position fixed
 ***********************/
$('#topNav').imagesLoaded().done(ev => {
  var
    $nav = $('#topNav'),
    $window = $(window),
    navHeight = null;

  $(window).on('scroll touchmove', ev => {
    if (navHeight) return;

    fix();
    return;
  });

  $(window).on('resize', () => {
    fix();
    return;
  });

  function fix () {
    navHeight = $nav.outerHeight();
    if ($window.width() >= 768) {
      $('body').css({ marginTop: ''});
      $nav.css({
        position: '',
        top: '',
        width: '',
        zIndex: ''
      });
      return;
    }
    $('body').css({ marginTop: navHeight });
    $nav.css({
      position: 'fixed',
      top: '0',
      width: '100%',
      zIndex: '999'
    });
  }
});

